/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:46
 * @LastEditTime: 2021-03-03 14:37:59
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\filter\trsStrToAbs\trsStrToAbs.js
 * @Description: 
 */
'use strict';

/**
* Author:XCL
*
* Time:2016-01-22
*
* Description:将正数或负数的字符串转换成number类型的正数
*/
angular.module('trsStrToAbsModule', [])
    .filter('trsStrToAbs', [function(){
        return function(str, param){
            if (angular.isUndefined(param)){
                str = Math.abs(parseInt(str));
            } else {
                str = param;
            }
            return str;
        };
    }]);
